import React, { useRef, useState } from 'react';
import { View, Animated, StatusBar, ScrollView } from 'react-native';
import { connect } from 'react-redux';

import { scale, width } from '@components/frame';
import { isWeb, isPhone, isAndroid } from '@helpers';

import { getAllFeatureFlags } from '@reducers/user';

import ColorWrapper from '@styles/colors';

import Details from './components/details';

const Environment = (props) => {
  const {
    C,
    user: { userInfo = {} },
  } = props;
  const [headerActive, setHeaderActive] = useState(false);

  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scrollRef = useRef(null);

  const startFrom = 30;

  const scrollListener = ({ nativeEvent }) => {
    const {
      contentOffset: { y },
    } = nativeEvent;

    if (isAndroid) {
      if (y > scale(startFrom)) {
        if (!headerActive) {
          setHeaderActive(true);
          StatusBar.setBackgroundColor(C('Background / Light / System'));
        }
      } else {
        if (headerActive) {
          setHeaderActive(false);
          StatusBar.setBackgroundColor(C('Background/Light/Detail'));
        }
      }
    }
  };

  return (
    <View style={{ width: '100%', height: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }} key="AccoutDetails">
      <ScrollView>
        <View
          style={{
            width,
            height: '100%',
            alignContent: 'center',
            paddingTop: scale(isPhone ? 150 : 162),
            paddingHorizontal: scale(isPhone ? 15 : 195),
            paddingBottom: scale(50),
          }}
        >
          <Details {...props} />
        </View>
      </ScrollView>
    </View>
  );
};

export default connect(({ user }) => ({ user }), { getAllFeatureFlags })(ColorWrapper(Environment));
